interface PromiseWithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
}

// eslint-disable-next-line unused-imports/no-unused-vars
interface PromiseConstructor {
  withResolvers<T>(): PromiseWithResolvers<T>;
}

if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = <T>() => {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve: resolve!, reject: reject! };
  };
}

if (typeof Promise.allSettled !== 'function') {
  Promise.allSettled = (promises: any) =>
    Promise.all(
      promises.map((promise: any) =>
        Promise.resolve(promise).then(
          value => ({ status: 'fulfilled', value }),
          reason => ({ status: 'rejected', reason }),
        ),
      ),
    );
}

if (typeof Array.prototype.at !== 'function') {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function (index) {
    if (index < 0) {
      index = this.length + index;
    }

    return this[index];
  };
}
